import { ReportFormat } from "@common/helpers/reports";
import {
    ArAgingBucket,
    AR_AGING_BUCKET_LABELS,
} from "@common/types/reports/ar-aging";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
} from "@common/types/reports/report-type";
import { exportArAgingDetail } from "@api/accountingReports.api";
import { AccountingReportFilters } from "@components/accounting/types";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

interface DownloadParams {
    format: ReportFormat;
    /** yyyy-MM-dd, resolved from the report response so the filename always matches what's shown. */
    asOfDate: string;
}

export function useArAgingDetailDownload(
    filters: AccountingReportFilters,
    buckets: ArAgingBucket[] | undefined,
) {
    return useFileDownload(async ({ format, asOfDate }: DownloadParams) => {
        const response = await exportArAgingDetail(filters, format, buckets);
        if (!response) {
            return;
        }

        const reportTypeTitle =
            ACCOUNTING_REPORT_LABELS[AccountingReportType.AR_AGING_DETAIL];
        const bucketSuffix = buckets?.length
            ? ` - ${buckets.map((bucket) => AR_AGING_BUCKET_LABELS[bucket]).join(", ")}`
            : "";
        const fileName = `${reportTypeTitle}${bucketSuffix} as of ${asOfDate}.${format}`;

        saveBlobResponse(response, fileName);
    });
}
